// extracted by mini-css-extract-plugin
export default {"app-notched-outline":"dbe501","app-notched-outline--notched":"b6fcec","app-notched-outline--visible":"e96900"};